import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#464646",
      "clip-path": "url(#clip0_2743_13014)"
    }, [
      _createElementVNode("path", { d: "M12.082 10.557a5.3 5.3 0 0 0-.99.971c-.844-.377-1.858-.617-3.028-.617-3.92 0-6.09 2.68-6.09 4.124 0 .184.095.245.317.245h7.577q.017.689.203 1.322h-7.37c-1.427 0-2.101-.438-2.101-1.4 0-2.294 2.827-5.613 7.464-5.613 1.559 0 2.913.376 4.018.968m-.328-6.168c0 2.259-1.657 4.106-3.69 4.106-2.024 0-3.69-1.839-3.69-4.089 0-2.224 1.666-4.018 3.69-4.018 2.042 0 3.69 1.76 3.69 4m-6.004.017c0 1.55 1.067 2.767 2.314 2.767 1.264 0 2.315-1.235 2.315-2.784 0-1.532-1.042-2.68-2.315-2.68C6.8 1.71 5.75 2.884 5.75 4.407M15 19.588h.734c.265 0 .47-.167.53-.438l.204-.867c.12-.026.256-.088.376-.149l.735.455c.23.15.47.15.674-.06l.504-.526c.18-.202.205-.447.051-.7l-.435-.762c.077-.114.102-.228.145-.35l.846-.202a.56.56 0 0 0 .435-.552v-.744c0-.262-.18-.455-.435-.525l-.829-.21c-.06-.149-.11-.263-.154-.359l.462-.78a.55.55 0 0 0-.069-.682l-.52-.517c-.189-.201-.445-.245-.658-.105l-.752.482c-.137-.07-.256-.105-.376-.15l-.205-.875a.535.535 0 0 0-.53-.437H15a.54.54 0 0 0-.53.437l-.196.867c-.145.053-.264.088-.393.158l-.743-.482c-.196-.131-.47-.096-.657.105l-.504.517a.556.556 0 0 0-.094.683l.47.779a10 10 0 0 0-.146.359l-.837.21c-.256.07-.427.272-.427.525v.745c0 .271.171.481.427.551l.846.201c.051.123.094.237.145.35l-.435.771c-.137.245-.12.508.06.692l.495.525c.188.21.444.202.674.061l.744-.455c.145.07.256.123.375.149l.197.867a.53.53 0 0 0 .53.438m.367-3.065c-.786 0-1.427-.656-1.427-1.453 0-.806.64-1.462 1.427-1.462.777 0 1.417.656 1.417 1.462 0 .797-.64 1.453-1.417 1.453" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2743_13014" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }